// Localidades de Bogotá
export const bogotaLocalities: string[] = [
  'Antonio Nariño',
  'Barrios Unidos',
  'Bosa',
  'Chapinero',
  'Ciudad Bolívar',
  'Engativá',
  'Fontibón',
  'Kennedy',
  'La Candelaria',
  'Los Mártires',
  'Puente Aranda',
  'Rafael Uribe Uribe',
  'San Cristóbal',
  'Santa Fe',
  'Suba',
  'Sumapaz',
  'Teusaquillo',
  'Tunjuelito',
  'Usaquén',
  'Usme'
];

// Lista única de barrios de Bogotá (sin duplicados)
export const allBogotaNeighborhoods: string[] = [
  '12 de Octubre',
  '20 de Julio',
  'Abraham Lincoln',
  'Aeropuerto',
  'Álamos',
  'Álamos Norte',
  'Américas',
  'Arborizadora',
  'Arborizadora Alta',
  'Barrancas',
  'Bavaria',
  'Bello Horizonte',
  'Belén',
  'Benjamín Herrera',
  'Betania',
  'Bolivia',
  'Bonanza',
  'Bosa Central',
  'Bosa La Libertad',
  'Bosa Occidental',
  'Bosque Medina',
  'Boyacá Real',
  'Britalia',
  'Cabrera',
  'Campín',
  'Candelaria',
  'Cantalejo',
  'Capellanía',
  'Carvajal',
  'Casa Blanca',
  'Casa Blanca Suba',
  'Castilla',
  'Cedritos',
  'Centro',
  'Centro Administrativo',
  'Centro Histórico',
  'Centro Internacional',
  'Chapinero Alto',
  'Chapinero Central',
  'Chicó Norte',
  'Chicó Reservado',
  'Ciudad Jardín',
  'Ciudad Montes',
  'Ciudad Salitre',
  'Ciudad Salitre Oriental',
  'Claret',
  'Colina Campestre',
  'Comuneros',
  'Contador',
  'Country Club',
  'Cundinamarca',
  'Danubio',
  'Diana Turbay',
  'Eduardo Santos',
  'Egipto',
  'El Bosque',
  'El Centro',
  'El Chicó',
  'El Codito',
  'El Cortijo',
  'El Mochuelo',
  'El Nogal',
  'El Porvenir',
  'El Recreo',
  'El Refugio',
  'El Retiro',
  'El Rincón',
  'El Salitre',
  'El Tesoro',
  'Engativá Centro',
  'Fátima',
  'Fontibón Centro',
  'Galerías',
  'Garcés Navas',
  'Gorgonzola',
  'Gran Estación',
  'Gran Yomasa',
  'Hayuelos',
  'Inglés',
  'Isla del Sol',
  'Ismael Perdomo',
  'Jerusalén',
  'Kennedy Central',
  'La Alhambra',
  'La Aurora',
  'La Carolina',
  'La Catedral',
  'La Concordia',
  'La Esmeralda',
  'La Estanzuela',
  'La Florida',
  'La Floresta',
  'La Fragua',
  'La Gloria',
  'La Granja',
  'La Macarena',
  'La Magdalena',
  'La Merced',
  'La Paz',
  'La Peña',
  'La Perseverancia',
  'La Sabana',
  'La Soledad',
  'Las Acacias',
  'Las Cruces',
  'Las Ferias',
  'Las Margaritas',
  'Las Nieves',
  'Laureles',
  'Los Alcázares',
  'Los Andes',
  'Los Cedros',
  'Los Libertadores',
  'Los Rosales',
  'Lourdes',
  'Lucero',
  'Luna Park',
  'Marco Fidel Suárez',
  'Marruecos',
  'Minuto de Dios',
  'Modelia',
  'Modelo',
  'Monteblanco',
  'Muzu',
  'Muzú',
  'Nazareth',
  'Nicolás de Federmán',
  'Niza',
  'Normandía',
  'Nueva Tibabuyes',
  'Nuevo Muzu',
  'Pardo Rubio',
  'Parkway',
  'Patio Bonito',
  'Perdomo',
  'Perseverancia',
  'Policarpa',
  'Polo Club',
  'Pontevedra',
  'Portales del Norte',
  'Prado',
  'Puente Aranda',
  'Quiba',
  'Quinta Camacho',
  'Quinta Paredes',
  'Quirigua',
  'Quiroga',
  'Rafael Núñez',
  'Ramírez',
  'Restrepo',
  'Ricaurte',
  'Rincón',
  'Rosales',
  'Sagrado Corazón',
  'Salazar Gómez',
  'Salitre Greco',
  'San Antonio',
  'San Antonio Norte',
  'San Benito',
  'San Blas',
  'San Bernardino',
  'San Bernardo',
  'San Cristóbal',
  'San Cristóbal Alto',
  'San Diego',
  'San Fernando',
  'San Francisco',
  'San Isidro Patios',
  'San Jorge',
  'San José de Bavaria',
  'San José Sur',
  'San Juan',
  'San Martín',
  'San Martín de Porres',
  'San Pablo',
  'San Patricio',
  'San Rafael',
  'San Vicente',
  'Santa Ana',
  'Santa Bárbara',
  'Santa Cecilia',
  'Santa Fe Central',
  'Santa Isabel',
  'Santa Librada',
  'Santa Paula',
  'Santa Rosa',
  'Santa Sofía',
  'Santander',
  'Siete de Agosto',
  'Simón Bolívar',
  'Sosiego',
  'Suba Centro',
  'Suba Compartir',
  'Teusaquillo',
  'Tibabita',
  'Tibana',
  'Tibabuyes',
  'Timiza',
  'Tintal',
  'Tintal Norte',
  'Toberín',
  'Tunal',
  'Ciudad Tunal',
  'Unicentro',
  'Usaquén Centro',
  'Venecia',
  'Veraguas',
  'Verbenal',
  'Versalles',
  'Villa Elisa',
  'Villa Javier',
  'Villa Luz',
  'Villa Mayor',
  'Villemar',
  'Villaluz',
  'Voto Nacional',
  'Zona Franca',
  'Zona T'
];

// Mapeo de barrio → localidad (basado en división oficial de Bogotá)
export const neighborhoodToLocality: Record<string, string> = {
  // Santa Fe
  'La Paz': 'Santa Fe',
  'La Perseverancia': 'Santa Fe',
  'Perseverancia': 'Santa Fe',
  'Egipto': 'Santa Fe',
  'La Macarena': 'Santa Fe',
  'Las Cruces': 'Santa Fe',
  'Lourdes': 'Santa Fe',
  'Ramírez': 'Santa Fe',
  'Santa Fe Central': 'Santa Fe',
  'Las Nieves': 'Santa Fe',
  
  // Chapinero
  'Chapinero Alto': 'Chapinero',
  'Chapinero Central': 'Chapinero',
  'Chicó Norte': 'Chapinero',
  'Chicó Reservado': 'Chapinero',
  'El Chicó': 'Chapinero',
  'Pardo Rubio': 'Chapinero',
  'Quinta Camacho': 'Chapinero',
  'El Retiro': 'Chapinero',
  'Rosales': 'Chapinero',
  'Los Rosales': 'Chapinero',
  'Sagrado Corazón': 'Chapinero',
  
  // Usaquén
  'Usaquén Centro': 'Usaquén',
  'Country Club': 'Usaquén',
  'Los Cedros': 'Usaquén',
  'Cedritos': 'Usaquén',
  'Contador': 'Usaquén',
  'San Patricio': 'Usaquén',
  'Toberín': 'Usaquén',
  'Verbenal': 'Usaquén',
  'Santa Bárbara': 'Usaquén',
  'La Carolina': 'Usaquén',
  
  // Suba
  'Suba Centro': 'Suba',
  'Suba Compartir': 'Suba',
  'Niza': 'Suba',
  'Casa Blanca Suba': 'Suba',
  'Britalia': 'Suba',
  'Tibabuyes': 'Suba',
  'Nueva Tibabuyes': 'Suba',
  'Minuto de Dios': 'Suba',
  'Portales del Norte': 'Suba',
  'Rincón': 'Suba',
  'Tibabita': 'Suba',
  
  // Engativá
  'Engativá Centro': 'Engativá',
  'Garcés Navas': 'Engativá',
  'Las Ferias': 'Engativá',
  'Boyacá Real': 'Engativá',
  'Bonanza': 'Engativá',
  'Álamos': 'Engativá',
  'Álamos Norte': 'Engativá',
  'Normandía': 'Engativá',
  'Bolivia': 'Engativá',
  
  // Fontibón
  'Fontibón Centro': 'Fontibón',
  'Aeropuerto': 'Fontibón',
  'Modelia': 'Fontibón',
  'Capellanía': 'Fontibón',
  'Zona Franca': 'Fontibón',
  'Hayuelos': 'Fontibón',
  
  // Kennedy
  'Kennedy Central': 'Kennedy',
  'Timiza': 'Kennedy',
  'Patio Bonito': 'Kennedy',
  'Tintal': 'Kennedy',
  'Tintal Norte': 'Kennedy',
  'Américas': 'Kennedy',
  'Bavaria': 'Kennedy',
  'Carvajal': 'Kennedy',
  
  // Bosa
  'Bosa Central': 'Bosa',
  'Bosa La Libertad': 'Bosa',
  'Bosa Occidental': 'Bosa',
  
  // Ciudad Bolívar
  'Ismael Perdomo': 'Ciudad Bolívar',
  'Perdomo': 'Ciudad Bolívar',
  'Lucero': 'Ciudad Bolívar',
  'El Mochuelo': 'Ciudad Bolívar',
  'Jerusalén': 'Ciudad Bolívar',
  'Arborizadora': 'Ciudad Bolívar',
  'Arborizadora Alta': 'Ciudad Bolívar',
  'Quiba': 'Ciudad Bolívar',
  
  // Tunjuelito
  'Tunal': 'Tunjuelito',
  'Ciudad Tunal': 'Tunjuelito',
  'Venecia': 'Tunjuelito',
  
  // Rafael Uribe Uribe
  'Diana Turbay': 'Rafael Uribe Uribe',
  'Marruecos': 'Rafael Uribe Uribe',
  'Quiroga': 'Rafael Uribe Uribe',
  'San José Sur': 'Rafael Uribe Uribe',
  'Marco Fidel Suárez': 'Rafael Uribe Uribe',
  
  // San Cristóbal
  'San Cristóbal': 'San Cristóbal',
  'San Cristóbal Alto': 'San Cristóbal',
  '20 de Julio': 'San Cristóbal',
  'La Gloria': 'San Cristóbal',
  'Sosiego': 'San Cristóbal',
  
  // Usme
  'Gran Yomasa': 'Usme',
  'Comuneros': 'Usme',
  
  // Antonio Nariño
  'Restrepo': 'Antonio Nariño',
  'Santa Isabel': 'Antonio Nariño',
  'Eduardo Santos': 'Antonio Nariño',
  'Luna Park': 'Antonio Nariño',
  'Villa Mayor': 'Antonio Nariño',
  
  // Puente Aranda
  'Puente Aranda': 'Puente Aranda',
  'Ciudad Montes': 'Puente Aranda',
  'Cundinamarca': 'Puente Aranda',
  
  // La Candelaria
  'Candelaria': 'La Candelaria',
  'La Catedral': 'La Candelaria',
  'Centro Histórico': 'La Candelaria',
  'Belén': 'La Candelaria',
  
  // Teusaquillo
  'Teusaquillo': 'Teusaquillo',
  'Galerías': 'Teusaquillo',
  'Campín': 'Teusaquillo',
  'Parkway': 'Teusaquillo',
  'Nicolás de Federmán': 'Teusaquillo',
  'Gran Estación': 'Teusaquillo',
  'Ciudad Salitre': 'Teusaquillo',
  'Ciudad Salitre Oriental': 'Teusaquillo',
  'El Salitre': 'Teusaquillo',
  'Salitre Greco': 'Teusaquillo',
  
  // Los Mártires
  'Ricaurte': 'Los Mártires',
  'Voto Nacional': 'Los Mártires',
  'La Estanzuela': 'Los Mártires',
  
  // Barrios Unidos
  'Siete de Agosto': 'Barrios Unidos',
  '12 de Octubre': 'Barrios Unidos',
  'Los Alcázares': 'Barrios Unidos',
  'Los Andes': 'Barrios Unidos',
  'Modelo': 'Barrios Unidos',
  'Simón Bolívar': 'Barrios Unidos',
};

// Obtener todos los barrios
export function getAllNeighborhoods(): string[] {
  return allBogotaNeighborhoods;
}

// Obtener la localidad a partir del barrio
export function getLocalityFromNeighborhood(neighborhood: string): string | null {
  return neighborhoodToLocality[neighborhood] || null;
}

// Normalizar string: quitar tildes, ñ → n, mayúsculas → minúsculas
export function normalizeString(str: string): string {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Quitar tildes
    .replace(/ñ/g, 'n')
    .trim();
}

// Coordenadas aproximadas de barrios de Bogotá (centro de cada barrio)
export const neighborhoodCoordinates: Record<string, { lat: number; lng: number }> = {
  // Santa Fe
  'La Paz': { lat: 4.6034, lng: -74.0654 },
  'La Perseverancia': { lat: 4.6189, lng: -74.0598 },
  'Perseverancia': { lat: 4.6189, lng: -74.0598 },
  'Egipto': { lat: 4.6098, lng: -74.0687 },
  'La Macarena': { lat: 4.6056, lng: -74.0712 },
  'Las Cruces': { lat: 4.5945, lng: -74.0823 },
  'Lourdes': { lat: 4.6012, lng: -74.0734 },
  'Ramírez': { lat: 4.5987, lng: -74.0789 },
  'Santa Fe Central': { lat: 4.6123, lng: -74.0745 },
  'Las Nieves': { lat: 4.6089, lng: -74.0712 },
  
  // Chapinero
  'Chapinero Alto': { lat: 4.6234, lng: -74.0567 },
  'Chapinero Central': { lat: 4.6512, lng: -74.0634 },
  'Chicó Norte': { lat: 4.6589, lng: -74.0543 },
  'El Chicó': { lat: 4.6534, lng: -74.0598 },
  'Pardo Rubio': { lat: 4.6423, lng: -74.0489 },
  
  // Tunjuelito
  'Abraham Lincoln': { lat: 4.5656, lng: -74.1289 },
  'Tunal': { lat: 4.5734, lng: -74.1267 },
  'Tunjuelito': { lat: 4.5723, lng: -74.1234 },
  
  // Teusaquillo
  'Teusaquillo': { lat: 4.6456, lng: -74.0923 },
  'Galerías': { lat: 4.6523, lng: -74.0834 },
  'La Esmeralda': { lat: 4.6389, lng: -74.0876 },
  'Palermo': { lat: 4.6312, lng: -74.0789 },
  
  // Kennedy
  'Kennedy Central': { lat: 4.6234, lng: -74.1523 },
  'Timiza': { lat: 4.6123, lng: -74.1634 },
  'Américas': { lat: 4.6289, lng: -74.1489 },
  'Bavaria': { lat: 4.6456, lng: -74.1345 },
  'Carvajal': { lat: 4.6012, lng: -74.1567 },
  'Castilla': { lat: 4.6345, lng: -74.1423 },
  'Gran Britalia': { lat: 4.6178, lng: -74.1689 },
  'Patio Bonito': { lat: 4.6523, lng: -74.1756 },
  'Tintal': { lat: 4.6689, lng: -74.1823 },
  
  // Suba
  'Suba Centro': { lat: 4.7512, lng: -74.0912 },
  'Rincón': { lat: 4.7345, lng: -74.0823 },
  'Tibabuyes': { lat: 4.7234, lng: -74.1045 },
  'Niza': { lat: 4.6989, lng: -74.0534 },
  'La Alhambra': { lat: 4.7123, lng: -74.0678 },
  'Ciudad Hunza': { lat: 4.7456, lng: -74.1123 },
  
  // Engativá
  'Engativá Centro': { lat: 4.6912, lng: -74.1134 },
  'Garcés Navas': { lat: 4.7023, lng: -74.1234 },
  'Las Ferias': { lat: 4.6823, lng: -74.1056 },
  'Boyacá Real': { lat: 4.7156, lng: -74.1312 },
  'Bonanza': { lat: 4.7234, lng: -74.1389 },
  'Álamos': { lat: 4.6945, lng: -74.1423 },
  'Álamos Norte': { lat: 4.6989, lng: -74.1456 },
  'Normandía': { lat: 4.7089, lng: -74.1367 },
  'Bolivia': { lat: 4.7012, lng: -74.1289 },
  
  // Antonio Nariño
  'Restrepo': { lat: 4.5912, lng: -74.0989 },
  'Santa Isabel': { lat: 4.5845, lng: -74.1023 },
  'Eduardo Santos': { lat: 4.5978, lng: -74.1067 },
  'Luna Park': { lat: 4.5823, lng: -74.1089 },
  'Villa Mayor': { lat: 4.5789, lng: -74.1134 },
};

// Calcular distancia entre dos coordenadas usando fórmula de Haversine (en km)
export function calculateDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 6371; // Radio de la Tierra en km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Encontrar el barrio más cercano a unas coordenadas dentro de una localidad
export function findNearestNeighborhood(
  lat: number,
  lng: number,
  localidad: string
): string | null {
  const barriosDeLocalidad = allBogotaNeighborhoods.filter(b => {
    return neighborhoodToLocality[b] === localidad;
  });

  if (barriosDeLocalidad.length === 0) return null;

  let nearestBarrio = barriosDeLocalidad[0];
  let minDistance = Infinity;

  for (const barrio of barriosDeLocalidad) {
    const coords = neighborhoodCoordinates[barrio];
    if (coords) {
      const distance = calculateDistance(lat, lng, coords.lat, coords.lng);
      if (distance < minDistance) {
        minDistance = distance;
        nearestBarrio = barrio;
      }
    }
  }

  return nearestBarrio;
}
